export default __webpack_public_path__ + "static/media/UI_Main.min.4cf8911e.png";